import classes from './Badge.module.scss';

interface SqareBadgeProps {
  count: number
}

/**
 * Returns the Square badge to show count
 */
const SquareBadge = ({ count }: SqareBadgeProps) => (
  <div className={classes.container}>
    <div className={classes.text}>
      {count}
    </div>
  </div>
  );

  export default SquareBadge;
